import HttpClient, { RequestEntryParams } from '@/bundles/Http/transport/HttpClient';
import { HttpMethods } from '@/bundles/Http/enum/HttpMethods';

export default class HttpTransport {
  private readonly client: HttpClient;

  constructor (client: HttpClient) {
    this.client = client;
  }

  /**
   * Make get request
   * @param {string} url
   * @param {any} query
   * @return {Promise}
   * */
  public get (url: string, query: any = {}) {
    return this.makeRequest({ method: HttpMethods.get, query, url });
  }

  /**
   * Make post request
   * @param {string} url
   * @param {any} body
   * @param headers
   * @return {Promise}
   * */
  public post (url: string, body: any, headers: Record<string, string> = {}) {
    return this.makeRequest({
      method: HttpMethods.post,
      data: body,
      url,
      headersEntry: headers,
    });
  }

  /**
   * Make put request
   * @param {string} url
   * @param {any} body
   * @return {Promise}
   * */
  public put (url: string, body: any, headers: Record<string, string> = {}) {
    const payload: any = {
      method: HttpMethods.put,
      data: body,
      url,
    };
    if (headers && Object.keys(headers).length) {
      payload.headersEntry = headers;
    }
    return this.makeRequest(payload);
  }

  /**
   * Make patch request
   * @param {string} url
   * @param {any} body
   * @param headers
   * @return {Promise}
   * */
  public patch (url: string, body: any, headers: Record<string, string> = {}) {
    return this.makeRequest({
      method: HttpMethods.patch,
      data: body,
      url,
      headersEntry: headers,
    });
  }

  /**
   * Make delete request
   * @param {string} url
   * @return {Promise}
   * */
  public delete (url: string) {
    return this.makeRequest({
      method: HttpMethods.delete,
      url,
    });
  }

  /**
   * Make API request
   * @param {HttpMethods} method
   * @param {String} url
   * @param {any} [payload={}]
   * @param {any} [query={}]
   * @return {Promise<any>}
   * */
  private makeRequest ({
    method,
    url,
    query = {},
    data = {},
    headersEntry = {},
  }: RequestEntryParams): Promise<any> {
    return this.client.request({ url, method, data, query, headersEntry });
  }
}
